import { Models } from "@rematch/core";

import { pageModel } from "./pages/pageModel";
import { mediaModel } from "./media/mediaModel";
import { languageModel } from "./languages/languageModel";
import { translationModel } from "./languages/translationModel";
import { configModel } from "./config/configModel";
import { menuModel } from "./menus/menuModel";
import { footerModel } from "./footer/footerModel";
import { toastModel } from "./toast/toastModel";
import { spinnerModel } from "./spinner/spinnerModel";
import { currentPageModel } from "./currentPage/currentPageModel";
import { auth } from "./auth/auth";
import { userModel } from "./users/userModel";
import { mailModel } from "./mails/mailModel";

export interface RootModel extends Models<RootModel> {
  auth: typeof auth;
  mailModel: typeof mailModel;
  pageModel: typeof pageModel;
  mediaModel: typeof mediaModel;
  languageModel: typeof languageModel;
  translationModel: typeof translationModel;
  menuModel: typeof menuModel;
  configModel: typeof configModel;
  footerModel: typeof footerModel;
  toastModel: typeof toastModel;
  spinnerModel: typeof spinnerModel;
  currentPageModel: typeof currentPageModel;
  userModel: typeof userModel;
}

export const models: RootModel = {
  auth,
  mailModel,
  pageModel,
  mediaModel,
  languageModel,
  translationModel,
  menuModel,
  configModel,
  footerModel,
  toastModel,
  spinnerModel,
  currentPageModel,
  userModel,
};
